import PropTypes from 'prop-types'
import React from 'react'

export default function Checkbox({ id, children, ...rest }) {
  const style = 'mr3 mr4-ns'

  return (
    <label className="db lh-copy f6 f5-ns mb3 mb4-ns gray">
      <input
        type="checkbox"
        id={id}
        className={style}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
        {...rest}
      />
      {children}
    </label>
  )
}

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}
